import React, { Fragment } from 'react'
import AddUsersToFeatureGroup from 'components/mutations/AddUsersToFeatureGroup'
import EmptyListItem from '../components/EmptyListItem'
import ListBox from 'components/ListBox'
import ListRow from 'components/ListRow'
import gql from 'graphql-tag'
import MoreMenu from 'components/MoreMenu'
import RemoveUserModal from './components/RemoveUserModal'
import RemoveUsersFromFeatureGroupMutation from 'components/mutations/RemoveUsersFromFeatureGroup'
import RouteAdminFeaturesGroupUsersQuery from './users.query'
import Toggle from 'components/Toggle'
import styled from 'react-emotion'
import {
  Autocomplete,
  createApolloDataSource,
  spacer,
  withNotifier
} from 'stylist'
import { compose, prop } from 'utils/fp'
import { connectionNodes } from 'utils/relay'
import { Query } from 'react-apollo'

const usersDataSource = createApolloDataSource({
  query: gql`
    query GroupUsersQuery($search: String!, $userCount: Int!) {
      users(first: $userCount, search: $search) {
        edges {
          node {
            id
            firstName
            lastName
            email
          }
        }
      }
    }
  `,
  variables: search => ({ userCount: 9999, search }),
  getData: compose(
    connectionNodes,
    prop('users')
  ),
  loadWithoutInput: true
})

const AddUserContainer = styled.section`
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${spacer(4)};
`

const USER_HAS_BEEN_ADDED_ERROR = /has already been added/

const serializeError = ({ graphQLErrors }) =>
  USER_HAS_BEEN_ADDED_ERROR.test(graphQLErrors[0].message)
    ? 'User has already been added'
    : 'Something went wrong'

const RouteAdminFeaturesGroupUsers = ({
  match: {
    params: { groupId }
  },
  notify
}) => (
  <Query
    query={RouteAdminFeaturesGroupUsersQuery}
    variables={{ groupId, userCount: 100 }}
  >
    {({ loading, data: { group } }) => (
      <Fragment>
        <AddUsersToFeatureGroup group={group}>
          {({ addUsersToGroup }) => (
            <AddUserContainer>
              <Autocomplete
                name="users"
                dataSource={usersDataSource}
                formatItem={({ firstName, lastName, email }) =>
                  `${firstName} ${lastName} (${email})`
                }
                onChange={(user, { clearSelection }) =>
                  user &&
                  addUsersToGroup([user]).then(clearSelection, error => {
                    notify('danger', serializeError(error))
                    clearSelection()
                  })
                }
                placeholder="Add a user..."
                width="400px"
              />
            </AddUserContainer>
          )}
        </AddUsersToFeatureGroup>
        <ListBox>
          {loading ? (
            <ListBox.Loader />
          ) : group.users.edges.length ? (
            group.users.edges.map(({ node: user }) => (
              <ListBox.Item hover key={user.id}>
                <ListRow templateColumns="auto 1fr auto">
                  <ListRow.Cell>
                    <strong>
                      {user.firstName} {user.lastName}
                    </strong>{' '}
                  </ListRow.Cell>
                  <ListRow.Cell>{user.email}</ListRow.Cell>
                  <ListRow.Cell actions>
                    <MoreMenu horizontal>
                      <Toggle
                        initial={false}
                        render={({ on, enable, disable }) => (
                          <Fragment>
                            <RemoveUsersFromFeatureGroupMutation group={group}>
                              {({ removeUsersFromGroup }) => (
                                <RemoveUserModal
                                  user={user}
                                  group={group}
                                  onDelete={() => removeUsersFromGroup([user])}
                                />
                              )}
                            </RemoveUsersFromFeatureGroupMutation>
                          </Fragment>
                        )}
                      />
                    </MoreMenu>
                  </ListRow.Cell>
                </ListRow>
              </ListBox.Item>
            ))
          ) : (
            <EmptyListItem>
              No users have been added to this group
            </EmptyListItem>
          )}
        </ListBox>
      </Fragment>
    )}
  </Query>
)

export default withNotifier(RouteAdminFeaturesGroupUsers)



// WEBPACK FOOTER //
// ./src/routes/admin/features/group/users.js